<section class="container flex-container column align-center">
    <h1>404</h1>
    <p>Page Not Found</p>
</section>